/**
 * Injection tokens для ObjectCardComponent
 * Используется для предоставления адаптера в компонент
 */

import { InjectionToken } from '@angular/core';

import { IObjectCardAdapter } from './object-card.adapter.interface';

export const OBJECT_CARD_ADAPTER_TOKEN = new InjectionToken<IObjectCardAdapter>(
  'OBJECT_CARD_ADAPTER_TOKEN',
  {
    providedIn: 'root',
    factory: () => {
      throw new Error(
        'ObjectCardAdapter must be provided! ' +
          'Add the adapter provider to your module using the OBJECT_CARD_ADAPTER_TOKEN token.',
      );
    },
  },
);
